import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL ve Anon Key tanımlanmamış');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      users: {
        Row: {
          id: string;
          auth_id: string;
          username: string;
          email: string;
          avatar_url: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          auth_id: string;
          username: string;
          email: string;
          avatar_url?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          auth_id?: string;
          username?: string;
          email?: string;
          avatar_url?: string | null;
          updated_at?: string;
        };
      };
      topics: {
        Row: {
          id: string;
          user_id: string;
          title: string;
          description: string;
          category: string;
          is_anonymous: boolean;
          votes_right: number;
          votes_wrong: number;
          status: 'active' | 'closed';
          summary: string | null;
          created_at: string;
          ends_at: string;
          closed_at: string | null;
        };
        Insert: {
          id?: string;
          user_id: string;
          title: string;
          description: string;
          category: string;
          is_anonymous?: boolean;
          votes_right?: number;
          votes_wrong?: number;
          status?: 'active' | 'closed';
          summary?: string | null;
          created_at?: string;
          ends_at?: string;
          closed_at?: string | null;
        };
        Update: {
          votes_right?: number;
          votes_wrong?: number;
          status?: 'active' | 'closed';
          summary?: string | null;
          closed_at?: string | null;
        };
      };
      votes: {
        Row: {
          id: string;
          topic_id: string;
          user_id: string;
          vote_type: 'right' | 'wrong';
          created_at: string;
        };
        Insert: {
          id?: string;
          topic_id: string;
          user_id: string;
          vote_type: 'right' | 'wrong';
          created_at?: string;
        };
        Update: {
          vote_type?: 'right' | 'wrong';
        };
      };
      comments: {
        Row: {
          id: string;
          topic_id: string;
          user_id: string;
          content: string;
          likes: number;
          created_at: string;
        };
        Insert: {
          id?: string;
          topic_id: string;
          user_id: string;
          content: string;
          likes?: number;
          created_at?: string;
        };
        Update: {
          content?: string;
          likes?: number;
        };
      };
      comment_likes: {
        Row: {
          id: string;
          comment_id: string;
          user_id: string;
          created_at: string;
        };
        Insert: {
          id?: string;
          comment_id: string;
          user_id: string;
          created_at?: string;
        };
      };
    };
  };
};
